<script>
import { Pie } from 'vue-chartjs'

export default {
  extends: Pie,
  props: {
    data: {
      type: Object,
      default: null,
    },
    options: {
      type: Object,
      default: null,
    },
  },
  mounted() {
    if (this.data && this.options) {
      this.renderChart(this.data, this.options)
    }
  },
  watch: {
    data: {
      handler() {
        if (this.$data._chart) {
          this.$data._chart.destroy()
        }
        if (this.data && this.options) {
          this.renderChart(this.data, this.options)
        }
      },
      deep: true
    },
    options: {
      handler() {
        if (this.$data._chart) {
          this.$data._chart.destroy()
        }
        if (this.data && this.options) {
          this.renderChart(this.data, this.options)
        }
      },
      deep: true
    }
  }
}
</script>
